// src/components/Tickets.jsx
import { useTheme, useMediaQuery } from "@mui/material";
import TicketsMobile from "./TicketsMobile";
import useTicketsLogic from "./useTicketsLogic";
import TicketsDesktop from "./TicketsDesktop";

export default function Tickets() {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const logic = useTicketsLogic(); // extraire toute ta logique métier dans ce hook

  return isMobile ? (
    <TicketsMobile {...logic} />
  ) : (
    <TicketsDesktop {...logic} />
  );
}
